import React from 'react';
import * as Icon from '@material-ui/icons';
import { IconButton, Tooltip, Grid, Typography } from '@material-ui/core';
import QlikHeaderBookmark from 'components/common/Qlik/QlikHeaderBookmark';
import PropTypes from 'prop-types';
import TemporaryDrawer from 'components/common/TemporaryDrawer';
import { defaultStyles } from 'utils/Theme';

const BookMark = ({ qsOptions, drawerWidth }) => {
    const classes = defaultStyles();
    return (
        <TemporaryDrawer
            anchor={'right'}
            ToggleButton={
                <div className={'c-dropdown dropdown '}>
                    <Tooltip title={'Bookmarks'} arrow>
                        <IconButton>
                            <Icon.BookmarkBorderOutlined
                                className={classes.colorPrimary}
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            }
            width={drawerWidth}
        >
            <QlikHeaderBookmark qsOptions={qsOptions} />
        </TemporaryDrawer>
    );
};

BookMark.propTypes = {
    drawerWidth: PropTypes.number,
    qsOptions: PropTypes.object,
};

export default BookMark;
